const Data = [
    {
        "name": "Afeerah Naseem",
        "position": "UG Coordinator",
        "imageUrl": "/assets/images/members/Heads24/AfeerahNaseem.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100087581197416",
        "linkedinLink": "https://www.linkedin.com/in/afeerah-naseem-59278a268/",
        "email": "afeerah.naseem@gyws.org"
    },
    {
        "name": "Adeeba Khan",
        "position": "UG Coordinator",
        "imageUrl": "/assets/images/members/Heads24/AdeebaKhan.png",
        "facebookLink": "https://www.facebook.com/profile.php?id=100087594696715",
        "linkedinLink": "https://www.linkedin.com/in/adeeba-khan-0168a1257/",
        "email": "adeeba.khan@gyws.org"
    },
    {
        name: "Mohit Pant",
        facebookLink: "https://www.facebook.com/profile.php?id=100085542944939",
        linkedinLink: "https://www.linkedin.com/in/mohit-pant-46790624b/",
        email: "mohit.pant@gyws.org",
        imageUrl: "/assets/images/members/Heads24/Mohit Pant.jpg",
        position: "UG Coordinator"
      },
]

export default Data;